import { Language } from "./language.enum";

/** Mirrors BannerSeverity in the backend's shared/types/banner.interface.ts. */
export enum BannerSeverity {
  Info = "info",
  Warning = "warning",
  Error = "error",
}

export type LocalizedBannerText = Partial<Record<Language, string>>;

export interface IBannerObject {
  _id: string;
  title?: LocalizedBannerText;
  message: LocalizedBannerText;
  severity: BannerSeverity;
  actionUrl?: string;
  actionText?: LocalizedBannerText;
  dismissible: boolean;
  isActive: boolean;
  startAt: string;
  endAt: string;
  createdBy: string;
  sourceLocale: Language;
  createdAt: string;
  updatedAt: string;
}

// POST /banners
export interface CreateBannerRequestBody {
  title?: LocalizedBannerText;
  message: LocalizedBannerText;
  sourceLocale: Language;
  severity: BannerSeverity;
  actionUrl?: string;
  actionText?: LocalizedBannerText;
  dismissible?: boolean;
  isActive?: boolean;
  startAt?: string;
  endAt: string;
}
export type CreateBannerResponse = IBannerObject;

// GET /banners
export interface GetBannersQuery {
  limit?: number;
  offset?: number;
}
export interface GetBannersResponse {
  banners: IBannerObject[];
  total: number;
}

// PUT /banners/{bannerId}
export interface UpdateBannerPath {
  bannerId: string;
}
export type UpdateBannerRequestBody = Partial<CreateBannerRequestBody>;
export type UpdateBannerResponse = IBannerObject;

// DELETE /banners/{bannerId}
export interface DeleteBannerPath {
  bannerId: string;
}
export interface DeleteBannerResponse {
  success: boolean;
}

// POST /banners/translate
export interface TranslateBannerRequestBody {
  sourceLocale: Language;
  title?: string;
  message: string;
  actionText?: string;
}
export interface TranslateBannerResponse {
  title?: LocalizedBannerText;
  message: LocalizedBannerText;
  actionText?: LocalizedBannerText;
}
